module.exports = __webpack_public_path__ + "img/Instructors_Qualifications.c282368a.png";